import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BasketService } from '@basket';

export const HasBasketGuard: CanActivateFn = (): boolean => {
  const basketService = inject(BasketService);
  const router = inject(Router);

  const hasBasket = !!basketService.basket();

  if (!hasBasket) {
    router.navigateByUrl('appliance-details');
    return false;
  }

  return true;
};
